import React, {useState} from 'react';
import {Checkbox, Form, Grid, Input, TextArea} from "semantic-ui-react";
import CityInput from "../../../components/CityInput";
import ConfirmModal from "../../../components/Modals/ConfirmModal";
import SelectPointModal from "./selectPointModal";
import SectionForm from "./sectionForm";
import {stringToAddress} from "./functions/addresses";
import Info from "../../../components/Info";
import InputDropdown from "../../../components/Dropdowns/InputDropdown";
import SemanticCountryPhoneInput from "../../../controls/semanticCountryPhoneInput";
import {getCarrierUiExtension} from "./carrierExtensions";

const PointSection = ({icon, label, form, changeParams, name, companyId, errors, isCreate, onChangeAddress}) => {
    const isRu = () => (form[`${name}Address`] || {}).countryCode === 'RU';
    const [isOpenAddressBookModal, setIsOpenAddressBookModal] = useState(false);
    const [isOpenStringAddressModal, setIsOpenStringAddressModal] = useState(false);
    const [postalCodeIdDisabled, setPostalCodeIsDisabled] = useState(isRu() && !!(form[`${name}Address`] || {}).postalCode);
    const [stringAddress, setStringAddress] = useState('');
    const carrierExtension = getCarrierUiExtension(form.selectedTariff);
    const showAdditionalPhoneFields = !carrierExtension.usePrimaryPhoneOnly(form.selectedTariff);
    const phoneHintText = carrierExtension.getPhoneHintText(form.selectedTariff);
    const showCourierMessage = isCreate && name === 'shipment' && carrierExtension.isCourierMessageAvailable(form.selectedTariff);
    const courierMessageInfoText = 'Курьер увидит этот текст еще до принятия заказа на доставку, что позволит исполнителю оценить: сможет ли он выполнить заказ. Сообщение должно быть очень коротким. Наши клиенты обычно указывают в этом поле фразы: "Бортовая Газель", "Водитель с Мед.книжкой", "нужна тележка" и т.д.';
    const senderCommentValue = form.senderComment || '';
    const senderCommentMaxLength = 50;
    const senderCommentEnabled = !!form.senderCommentEnabled;
    const isSenderCommentMaxReached = senderCommentValue.length >= senderCommentMaxLength;

    // Функция для определения, используется ли перевозчик КСЭ
    const isCSECarrier = () => {
        const carrierCode = form.selectedTariff && form.selectedTariff.carrierCode;
        return carrierCode && (
            carrierCode === 'CSE' ||
            carrierCode.includes('КСЭ') ||
            carrierCode.includes('Cse')
        );
    };

    // Получить максимальную длину комментария к адресу для КСЭ
    const getAddressCommentMaxLength = () => {
        return isCSECarrier() ? 100 : 255;
    };

    const changeCity = (nameParam, value, values = {}) => {
        const params = {
            [`${name}Address`]: {
                ...(form[`${name}Address`] || {}),
                ...values,
                [nameParam.includes('AddressCountry') ? 'countryCode' : nameParam]: value,
                id: null
            }
        }
        setPostalCodeIsDisabled(isRu() ? (nameParam !== 'postalCode' && params[`${name}Address`].postalCode) : false);
        changeParams(params);
    }

    const errorText = 'Адрес отправления не найден. Пожалуйста, внесите корректировки';

    return (
        <SectionForm
            actions={isCreate && <div className='total__change-btn'>
                <div className='total__change-btn_name' onClick={() => setIsOpenAddressBookModal(true)}>Из адресной
                    книги
                </div>
                <div className='total__change-btn_name' onClick={() => setIsOpenStringAddressModal(true)}>Адрес одной
                    строкой
                </div>
            </div>}
            icon={icon}
            label={label}
        >
            <Form className={isCreate ? '' : 'point-view'}>
                <Grid>
                    <Grid.Row columns={16}>
                        <Grid.Column width={4}>
                            <Form.Field className={errors[`${name}Address.city`] ? 'error-style' : ''}>
                                <label>
                                    Населенный пункт*
                                </label>
                                <CityInput
                                    isDisabled={!isCreate}
                                    name={name}
                                    value={form}
                                    onChange={(e, {name, value}, values) => changeCity(name, value, values)}
                                />
                            </Form.Field>
                        </Grid.Column>
                        <Grid.Column width={6}>
                            <Form.Field error={errors[`${name}Address.street`]}>
                                <label>
                                    Улица
                                </label>
                                <InputDropdown
                                    name={'street'}
                                    url={'parcels/addresses/streetAddressSuggestions'}
                                    disabled={!isCreate}
                                    value={(form[`${name}Address`] || {}).street || ''}
                                    onChange={changeCity}
                                    params={form[`${name}Address`]}
                                    paramsForSearchFields={[['city', 'cityName'], ['countryCode']]}
                                    dependentFields={['house', 'postalCode']}
                                    searchErrorText={errorText}
                                />
                            </Form.Field>
                        </Grid.Column>
                        <Grid.Column width={2}>
                            <Form.Field error={errors[`${name}Address.house`]}>
                                <label>
                                    Дом, корпус
                                </label>
                                <InputDropdown
                                    name={'house'}
                                    nameOption={'fullHouseAddress'}
                                    url={'parcels/addresses/houseAddressSuggestions'}
                                    disabled={!isCreate}
                                    value={(form[`${name}Address`] || {}).fullHouseAddress || ''}
                                    onChange={changeCity}
                                    params={form[`${name}Address`]}
                                    ignoredFields={['city', 'street']}
                                    paramsForSearchFields={[['city', 'cityName'], ['countryCode'], ['street', 'streetName']]}
                                    searchErrorText={errorText}
                                />
                            </Form.Field>
                        </Grid.Column>
                        <Grid.Column width={2}>
                            <Form.Field error={errors[`${name}Address.office`]}>
                                <label>
                                    Квартира/офис
                                </label>
                                <Input
                                    disabled={!isCreate}
                                    value={(form[`${name}Address`] || {}).office || ''}
                                    onChange={(e, {value}) => changeCity('office', value)}
                                />
                            </Form.Field>
                        </Grid.Column>
                        <Grid.Column width={2}>
                            <Form.Field error={errors[`${name}Address.postalCode`]}>
                                <label>
                                    Индекс
                                </label>
                                <Input
                                    disabled={!isCreate || postalCodeIdDisabled}
                                    value={(form[`${name}Address`] || {}).postalCode || ''}
                                    onChange={(e, {value}) => changeCity('postalCode', value)}
                                />
                            </Form.Field>
                        </Grid.Column>
                    </Grid.Row>

                    <Grid.Row columns={16}>
                        <Grid.Column width={16}>
                            <Form.Field error={errors[`${name}AddressComment`]} className='border-bottom'>
                                <label>
                                    Комментарий к адресу
                                </label>
                                <TextArea
                                    disabled={!isCreate}
                                    placeholder={'Этаж, подъезд, часы работы или другая информация'}
                                    value={form[`${name}AddressComment`] || ''}
                                    maxLength={getAddressCommentMaxLength()}
                                    onChange={(e, {value}) => changeParams({
                                        [`${name}AddressComment`]: value
                                    })}
                                    rows={3}
                                    style={{ 
                                        minHeight: 'auto',
                                        resize: 'vertical'
                                    }}
                                />
                                {isCSECarrier() && (
                                    <div style={{fontSize: '12px', color: '#888', marginTop: '4px'}}>
                                        Максимум 100 символов для КСЭ
                                    </div>
                                )}
                            </Form.Field>
                        </Grid.Column>
                    </Grid.Row>

                    <Grid.Row columns={16}>
                        <Grid.Column width={16}>
                            <Form.Field error={errors[`${name}ContactPersonName`]}>
                                <label>
                                    Контактное лицо*
                                </label>
                                <Input
                                    disabled={!isCreate}
                                    value={form[`${name}ContactPersonName`] || ''}
                                    maxLength={50}
                                    onChange={(e, {value}) => changeParams({
                                        [`${name}ContactPersonName`]: value
                                    })}
                                />
                            </Form.Field>
                        </Grid.Column>
                    </Grid.Row>
                    <Grid.Row columns={16}>
                        <Grid.Column width={16}>
                            <Form.Field error={errors[`${name}Company`]}>
                                <label>
                                    Компания
                                    {(name !== 'shipment' && form.selectedTariff && form.selectedTariff.isRecipientCompanyRequired) ?
                                        <span>
                                            *
                                           <Info
                                               className={'m-l-5'}
                                               name={'Компания'}
                                               text={'Это поле является обязательным по условиям ТК'}
                                           />
                                        </span>
                                        : ''}
                                </label>
                                <Input
                                    disabled={!isCreate}
                                    value={form[`${name}Company`] || ''}
                                    maxLength={50}
                                    onChange={(e, {value}) => changeParams({
                                        [`${name}Company`]: value
                                    })}
                                />
                            </Form.Field>
                        </Grid.Column>
                    </Grid.Row>
                    <Grid.Row columns={16}>
                        <Grid.Column width={4} style={{paddingRight: '0.25em'}}>
                            <Form.Field error={errors[`${name}PhoneNumber`]}>
                                <label>
                                    Телефон*
                                    {!!phoneHintText && <Info
                                        className={'m-l-5'}
                                        name={'Телефон'}
                                        text={phoneHintText}
                                    />}
                                </label>
                                <SemanticCountryPhoneInput
                                    disabled={!isCreate}
                                    value={form[`${name}PhoneNumber`] || ''}
                                    onChange={(e, {value}) => changeParams({
                                        [`${name}PhoneNumber`]: value
                                    })}
                                    defaultCountry="ru"
                                />
                            </Form.Field>
                        </Grid.Column>
                        {showCourierMessage && <Grid.Column width={12} className='courier-message-field-col'>
                            <Form.Field className='courier-message-field courier-message-field_inline' error={errors['senderComment']}>
                                <label>
                                    Короткое сообщение курьеру
                                    <Info
                                        className='carrier-tariff-inline__icon'
                                        name={'Короткое сообщение курьеру'}
                                        text={courierMessageInfoText}
                                        position={'right'}
                                        offset={[8]}
                                    />
                                </label>
                                <div className='courier-message-field__control'>
                                    <Checkbox
                                        checked={senderCommentEnabled}
                                        onChange={(e, data) => {
                                            changeParams({senderCommentEnabled: !!data.checked});
                                            if (!data.checked) {
                                                changeParams({senderComment: ''});
                                            }
                                        }}
                                    />
                                    <Input
                                        disabled={!senderCommentEnabled}
                                        maxLength={senderCommentMaxLength}
                                        value={senderCommentValue}
                                        placeholder='Например: нужна тележка'
                                        onChange={(e, {value}) => changeParams({senderComment: value})}
                                    />
                                </div>
                                {senderCommentEnabled && (
                                    <div className={`courier-message-field__hint ${isSenderCommentMaxReached ? 'courier-message-field__hint_limit' : ''}`}>
                                        {senderCommentValue.length}/{senderCommentMaxLength}
                                    </div>
                                )}
                            </Form.Field>
                        </Grid.Column>}
                        {showAdditionalPhoneFields && <Grid.Column width={4} style={{paddingLeft: '0.25em'}}>
                            <Form.Field error={errors[`${name}Ext1`]}>
                                <label>
                                    Доб. Номер1 (EXT.)
                                </label>
                                <Input
                                    disabled={!isCreate}
                                    value={form[`${name}Ext1`] || ''}
                                    onChange={(e, {value}) => changeParams({
                                        [`${name}Ext1`]: value
                                    })}
                                    style={{maxWidth: '8ch'}}
                                    maxLength={10}
                                />
                            </Form.Field>
                        </Grid.Column>}
                        {showAdditionalPhoneFields && <Grid.Column width={8}/>}
                        {!showAdditionalPhoneFields && !showCourierMessage && <Grid.Column width={12}/>}
                    </Grid.Row>
                    {showAdditionalPhoneFields && <Grid.Row columns={16}>
                        <Grid.Column width={4} style={{paddingRight: '0.25em'}}>
                            <Form.Field error={errors[`${name}AdditionalPhone`]}>
                                <label>
                                    Дополнительный телефон
                                </label>
                                <SemanticCountryPhoneInput
                                    disabled={!isCreate}
                                    value={form[`${name}AdditionalPhone`] || ''}
                                    onChange={(e, {value}) => changeParams({
                                        [`${name}AdditionalPhone`]: value
                                    })}
                                    defaultCountry="ru"
                                />
                            </Form.Field>
                        </Grid.Column>
                        <Grid.Column width={4} style={{paddingLeft: '0.25em'}}>
                            <Form.Field error={errors[`${name}Ext2`]}>
                                <label>
                                    Доб. номер2 (EXT.)
                                </label>
                                <Input
                                    disabled={!isCreate}
                                    value={form[`${name}Ext2`] || ''}
                                    onChange={(e, {value}) => changeParams({
                                        [`${name}Ext2`]: value
                                    })}
                                    style={{maxWidth: '8ch'}}
                                    maxLength={10}
                                />
                            </Form.Field>
                        </Grid.Column>
                        <Grid.Column width={8}/>
                    </Grid.Row>}
                </Grid>
            </Form>

            <ConfirmModal
                label={'Адрес одной строкой'}
                onConfirm={() => stringToAddress(stringAddress, setStringAddress, (data) => changeParams({
                    [`${name}Address`]: data
                }))}
                open={isOpenStringAddressModal}
                setOpen={setIsOpenStringAddressModal}
            >
                <Form>
                    <Grid>
                        <Grid.Row columns={16}>
                            <Grid.Column width={16}>
                                <Form.Field>
                                    <label>
                                        Адрес
                                    </label>
                                    <Input
                                        placeholder={'Введите или скопируйте адрес одной строкой'}
                                        value={stringAddress || ''}
                                        onChange={(e, {value}) => setStringAddress(value)}
                                    />
                                </Form.Field>
                            </Grid.Column>
                        </Grid.Row>
                    </Grid>
                </Form>
            </ConfirmModal>

            <SelectPointModal
                label={'Мои адреса'}
                open={isOpenAddressBookModal}
                setOpen={setIsOpenAddressBookModal}
                companyId={companyId}
                setPoint={(e, {value}) => onChangeAddress(name, value, true)}
            />
        </SectionForm>
    );
}

export default PointSection;


// WEBPACK FOOTER //
// ./App/pages/parcels/form_v3/pointSection.jsx